import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email, min, max, confirmed, numeric, min_value, max_value } from "vee-validate/dist/rules";

extend('verify_password', {
    message:
        `The password must contain at least: 1 uppercase letter, 1 lowercase letter and 1 number`,
    validate: value => {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])')
        return strongRegex.test(value)
    }
})

extend('new_password', {
    message: `The new password must be not same as old password`,
    validate: (value, [password]) => {
        return value !== password
    }
})

extend("required", {
    ...required,
    message: "This field is required"
});

extend("email", {
    ...email,
    message: "This field must be a valid email"
});

extend("numeric", {
    ...numeric,
    message: "This field must be a valid number"
});

extend("min_value", {
    ...min_value,
    message: (field, value) =>
        `This field must be greater than ${value.min}`
});

extend("max_value", {
    ...max_value,
    message: (field, value) => `This field must be lower than ${value.max}`
});

extend('confirmed', {
    ...confirmed,
    message: "The password do not match"
})

extend('min', {
    ...min,
    message: (field, min) => `This field must be at least ${min.length} characters`
})

extend('max', {
    ...max,
    message: (field, min) => `This field cannot be greater than ${min.length} characters`
})

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);